export default __webpack_public_path__ + "static/media/lock.b7b0ca82.svg";